<template>
    <input type="text" :placeholder="$t('services.inventory.compartment-seat-numbers')" v-model="item" />
</template>

<script>
export default {
  props: {
    seats: {
      default: '',
      type: String,
      required: false
    },
    rollingStockSeats: {
      default: () => ([]),
      type: Array,
      required: false
    }
  },
  data () {
    return {
      item: this.seats,
      itemSeats: this.rollingStockSeats
    }
  },
  created () {
    this.createSeats(this.seats)
  },
  methods: {
    createSeats (val) {
      if (val) {
        let seats = val.split(',')
        let rollingStockSeats = []
        seats.forEach((seat) => {
          let seatName = 'Plaats ' + seat.trim()
          let existingSeat = this.$_.find(this.itemSeats, { 'name': seatName })
          if (!existingSeat) {
            // Try without prefix
            existingSeat = this.$_.find(this.itemSeats, { 'name': seat.trim() })
          }
          if (existingSeat) {
            rollingStockSeats.push({ id: existingSeat.id, name: existingSeat.name })
          } else {
            rollingStockSeats.push({ name: seatName })
          }
        })
        this.$emit('update:seats', val)
        this.$emit('update:rollingStockSeats', rollingStockSeats)
      }
    }
  },
  watch: {
    item (val) {
      this.createSeats(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inventory/layout/Seats.vue